// extracted by mini-css-extract-plugin
export default {"container":"container_sjKDY","title":"title_kWsQY","texts":"texts_C_VGK","text":"text_GDClW","isSmall":"isSmall_E6BbQ"};